import { Platform }  from '@/proto/proto';
import { jwtDecode } from 'jwt-decode';

import UserRights = Platform.Service.Fondations.UserRights;

type TokenData = {
	['platform.token.owner']: any;
};

export function decodeToken(token: string): TokenData {
	return jwtDecode(token) || {};
}

export function getUserRightsFromTokenData(tokenData: TokenData) {
	return UserRights.decode(new TextEncoder().encode(tokenData['platform.token.owner']));
}

export function getRoleIdentifiersFromUserRights(userRights: UserRights) {
	return userRights.roles.map(role => role.urn?.identifier || '');
}